import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import Style from './SkeletonNode.module.css';

export const SkeletonNode = memo(({ id, data, isConnectable }) => {
  const isRootNode = data.isRootNode;
  const isParentNode = data.isParent;

  const colorScheme = {
    handle: '#98b5ea',
  };

  const styles = {
    rootNode: `${Style.container} ${Style.rootNode}`,
    parentNode: `${Style.container} ${Style.parentNode}`,
    leafNode: `${Style.container} ${Style.leafNode}`
  };

  const containerStyle = isRootNode ? styles.rootNode : isParentNode ? styles.parentNode : styles.leafNode;

  const handles = [];

  if (isRootNode) {
    if (id === 'skeleton-customer') {
      handles.push({ type: 'source', position: Position.Right, id: 'r' });
    } else if (id === 'skeleton-client') {
      handles.push({ type: 'target', position: Position.Left, id: 'l' });
    }
  } else if (isParentNode) {
    handles.push(
      { type: 'target', position: Position.Top, id: 't' },
      { type: 'source', position: Position.Bottom, id: 'b' }
    );
  } else {
    handles.push({ type: 'target', position: Position.Top, id: 't' });
    if (data.isSource) {
      handles.push({ type: 'source', position: Position.Right, id: 'r' });
    }
  }

  return (
    <div className={containerStyle}>
      <div className={Style.shimmer} />
      {handles.map(handle => (
        <Handle
          key={`${handle.id}-${handle.type}`}
          type={handle.type}
          position={handle.position}
          id={handle.id}
          isConnectable={false}
          style={{ background: colorScheme.handle, opacity: 0.5 }}
        />
      ))}
    </div>
  );
});

SkeletonNode.displayName = 'SkeletonNode';
